import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b09796d"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id", "aria-labelledby"]
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = { class: "fw-bold text-center w-100 fs-5 text-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-thumbs-up fs-5" }, null, -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode()
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = {
  key: 0,
  class: "d-flex justify-content-center mb-5"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner-border" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "px-lg-2 h-500 overflow-auto"
}
const _hoisted_13 = {
  key: 0,
  class: "d-flex align-items-center fw-bold fs-7 cursor-pointer col-6 col-lg-7"
}
const _hoisted_14 = { class: "text-name" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "fs-7 mar-right-0 text-end my-lg-0" }
const _hoisted_17 = { class: "modal-footer justify-content-center" }

import UserAliasIcon from '@/components/user-alias-icon/index.vue'
import Button from '@/components/button/index.vue'
import { numberWithCommas } from '@/constants/common.ts'
import { translate } from '@/languages/i18n'
import { computed, ComputedRef, ref } from 'vue'
import { useStore } from 'vuex'
import { ACCOUNT_STORE, POST_STORE } from '@/store/constants'
import { useRoute } from 'vue-router'
import { ReplayName } from '@/constants/common.ts'
import { Modal } from 'bootstrap'
import dayjs from 'dayjs'
import PortfolioAlumni from '@/views/community-admin/user-management/alumni-user/detail/components/PortfolioAlumni.vue'
import PortfolioUser from '@/views/community-admin/user-management/employee-user/detail/components/PortfolioUser.vue'

type InterestType = {
  chat_link: string
  created_at: string
  family_name: string
  given_name: string
  user_type: string
}


export default /*#__PURE__*/_defineComponent({
  props: {
  modalId: {
    type: String,
    default: 'like',
  },
},
  setup(__props) {



const modal = ref()
const route = useRoute()
const store = useStore()
const showModal = computed(() => store.getters[ACCOUNT_STORE.GETTERS.PROFILE_DETAIL]?.showModal)

const data = computed<ComputedRef<Array<InterestType>>>(() => store.getters[POST_STORE.GETTERS.LIKE]?.like)
const loading = computed(() => store.getters[POST_STORE.GETTERS.LIKE]?.loadingPosts)

const handleShowUser = async (id, userID, userType, is_deleted_in_30_days) => {
  if (is_deleted_in_30_days === 2 || userType === 'community_admin') {
    return
  }
  modal.value = new Modal(document.getElementById(userType === 'alumni' ? 'editProfileModal' : 'profileUserModal'))

  await store.dispatch(ACCOUNT_STORE.ACTIONS.SET_PROFILE_DETAIL, { id, userID, userType, isAdmin: true })
  if (showModal.value) {
    await modal.value?.show()
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "modal fade",
      id: __props.modalId,
      tabindex: "-1",
      "aria-labelledby": __props.modalId,
      "aria-hidden": "true"
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(['modal-dialog', _unref(route).path === `/${_unref(route).path.split('/')[1]}/communities/${_unref(route).params.id}` ? '' : 'modal-lg'])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, [
              _createTextVNode(_toDisplayString(_unref(translate)('like')), 1),
              _hoisted_5,
              _hoisted_6,
              _createElementVNode("span", null, _toDisplayString(_unref(loading) ? 0 : _unref(numberWithCommas)(_unref(data)?.length)), 1)
            ]),
            _hoisted_7
          ]),
          _createElementVNode("div", _hoisted_8, [
            (_unref(loading))
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
              : _createCommentVNode("", true),
            (!_unref(loading))
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data), (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item,
                      class: _normalizeClass(['py-2 d-flex align-items-center', index !== _unref(data).length - 1 ? 'border-bottom mb-4' : ''])
                    }, [
                      (item.user_type === 'community_admin')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _createVNode(UserAliasIcon, {
                              userType: item.user_type
                            }, null, 8, ["userType"]),
                            _createElementVNode("div", null, [
                              _createElementVNode("span", _hoisted_14, _toDisplayString(item.display_name), 1)
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            onClick: () => handleShowUser(_unref(route).params.id, item?.management_no, item?.user_type, item?.is_deleted_in_30_days),
                            class: "d-flex align-items-center fw-bold fs-7 cursor-pointer col-6 col-lg-7"
                          }, [
                            _createVNode(UserAliasIcon, {
                              userType: item.user_type
                            }, null, 8, ["userType"]),
                            _createElementVNode("span", null, _toDisplayString(item?.management_no + ' ' + _unref(ReplayName)(item?.is_deleted_in_30_days, item?.available, item?.family_name, item?.given_name, item?.user_type)) + _toDisplayString(item?.user_type == 'alumni' && item?.is_deleted_in_30_days !== 2 ? `（ ${item?.display_name} ）` : ''), 1)
                          ], 8, _hoisted_15)),
                      _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(dayjs)(item.created_at).format('YYYY/MM/DD HH:mm')), 1)
                    ], 2))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(Button, {
              title: _unref(translate)('close'),
              "data-bs-dismiss": "modal",
              type: 'secondary'
            }, null, 8, ["title"])
          ])
        ])
      ], 2)
    ], 8, _hoisted_1),
    _createVNode(PortfolioAlumni),
    _createVNode(PortfolioUser)
  ], 64))
}
}

})